// ─────────────────────────────────────────────────────────────────────────────
// FEATURE: Checkout / online payment  (API calls for Razorpay)
// The three public endpoints in backend/app/api/payments.py. The Razorpay key SECRET never reaches the browser: the
// server creates the Razorpay order (so the customer can't pay against an order we didn't make) and checks the
// signature Razorpay returns after payment. The key id it hands back is public, and "livemode: false" means Razorpay
// TEST mode (no real money moves).
// ─────────────────────────────────────────────────────────────────────────────
import { apiGet, apiPost } from "./api";

export interface PaymentConfig {
  enabled: boolean;
  /** Staff paused online payments (admin → Payments & APIs): no new payment can start; wallet-only orders still work. */
  paused?: boolean;
  keyId: string | null;
  /** false = Razorpay test mode; null when payments aren't configured. */
  livemode: boolean | null;
}

export interface PaymentOrder {
  orderId: string;
  amountPaise: number;
  currency: string;
  keyId: string;
  livemode: boolean;
}

export interface PaymentProof {
  orderId: string;
  paymentId: string;
  signature: string;
}

export const fetchPaymentConfig = () => apiGet<PaymentConfig>("/public/payments/config");

/** `receipt` is our order reference, so the Razorpay order and our order can be matched up. */
/** `delivery` (the saved address pin + basket subtotal) lets the backend refuse an out-of-zone order BEFORE any money moves. */
export const createPaymentOrder = (amountInr: number, receipt: string, delivery?: { lat: number; lng: number; subtotal: number }) =>
  apiPost<PaymentOrder>("/public/payments/orders", { amountInr, receipt, ...(delivery ?? {}) });

export const verifyPayment = (proof: PaymentProof) => apiPost<{ verified: boolean }>("/public/payments/verify", proof);
